import React from "react";
import PropTypes from 'prop-types';
import {
  findSiteId,
  HeaderBGColor
} from '../../helpers/Helper';

import Button from "@components/Button/Button";
import NewsletterV2 from "@components/NewsletterV2/NewsletterV2";
import NextImage from "@components/Image/NextImage";

import styles from "./PromoRibbon.module.css";

class PromoRibbon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNewsletter: false
    };
  }

  static propTypes = {
    classes: PropTypes.string,
    header: PropTypes.string,
    subheader: PropTypes.string,
    promoCards: PropTypes.array,
    button: PropTypes.bool,
    id: PropTypes.number,
    newsletterOptions: PropTypes.object,
    promoType: PropTypes.object,
    Newsletter_Settings: PropTypes.object,
  }

  static defaultProps = {}

  gridClasses = () => {
    let promoCardLength = this.props.promoCards.length;

    switch (promoCardLength) {
      case 5:
        return 'columns large-2 medium-12 small-12 ';
      case 4:
        return 'columns large-3 medium-12 small-12';
      case 3:
        return 'columns large-4 medium-12 small-12';
      case 2:
        return 'columns large-2 medium-6 small-12';
      case 1:
        return 'columns large-1 medium-6 small-12';
      default:
        return '';
    }
  }

  onSignUpToggle = () => {
    this.setState({
      showNewsletter: !this.state.showNewsletter
    });
  }

  renderNewsletter = () => {
    const isFunnelPage = this.props.promoType.promoType === 'categoryfunnel';
    let newsletterOptions = this.props.newsletterOptions;
    if (this.state.showNewsletter || isFunnelPage) {
      return (
        <NewsletterV2
          isDisplayModalChecked={true}
          displayModalTimeout=""
          displayModalAction="click"
          onSignUpToggle={this.onSignUpToggle}
          isChild={true}
          isModalOpen={this.state.showNewsletter}
          showButton={this.props.button}
          Newsletter_Settings={this.props.Newsletter_Settings}
          {...newsletterOptions.props}
          isFunnelPage={isFunnelPage}
        />
      );
    }
  };

  renderPriceTags = (price) => {
    let stylePrice = price.split(".");

    return (
      <div className={styles.Price}>
        <sup>$</sup> <span className={styles.dollar}>{stylePrice[0]}</span><sup>{stylePrice[1]}</sup>
      </div>
    );
  }

  getTitle = (header) => {
    let title = header ?
      <div className={[styles["promo-title"], "promo-title"].join(" ")}>
        {header}
      </div> : '';
    return title;
  }

  renderPromoCards = () => {
    if (this.props.promoCards && this.props.promoCards.length) {
      let image;
      let pointer = this.props.promoType.promoType === 'book' ? "pointer" : null;
      return this.props.promoCards.map((card, idx) => {
        let cardSiteId = card.link ? findSiteId(card.link) : '';
        let cardBackgoundColor = { background: cardSiteId ? HeaderBGColor(cardSiteId) : 'none' };
        // let endClass = idx + 1 == this.props.promoCards.length ? 'end' : '';

        if (card.link) {
          image = (
            <a href={card.link}><NextImage ImageUrl={card.image} keyGenerate={false} style={cardBackgoundColor} width={100} height={240} className={[this.props.parentClass['promoImage'], 'promoImage', this.props.parentClass[this.props.classes], this.props.classes].join(" ")} /></a>
          );
        } else {
          image = <NextImage ImageUrl={card.image} style={cardBackgoundColor} keyGenerate={false} width={150} height={240} className={[this?.props?.parentClass?.['promoImage'], 'promoImage', this?.props?.parentClass?.[this.props.classes], this.props.classes].join(" ")} />
        }

        return (
          <React.Fragment key={idx}>
            <div className={['promo-' + idx, styles['promos'], 'promos', ...this.gridClasses().split(' ').map(gridClass => `${styles[gridClass]} ${gridClass}`)].join(" ")} onClick={() => { this.props.promoType.promoType === 'book' ? this.onSignUpToggle() : null; }}>
              <div className={[this?.props?.parentClass?.["promoItem"], styles["promoItem"], "promoItem", pointer].join(" ")}>
                {image}
                {card.salePrice ? this.renderPriceTags(card.salePrice) : null}
                <p>{card.text}</p>
              </div>
            </div>
          </React.Fragment>
        );
      });
    }
  }


  render() {
    const promoType = this.props.promoType.promoType;
    let header = this.getTitle(this.props.header);
    let subheader = this.props.subheader ? <div className={[this?.props?.parentClass?.["promo-subheader"], styles["promo-subheader"], "promo-subheader"].join(" ")}>
      {this.props.subheader}
    </div>
      : null;
    let signUpButton = this.props.button ?
      <div className={[styles["button-wrapper"], "button-wrapper"].join(" ")}>
        <Button
          handleClick={() => this.onSignUpToggle()}
          text={this.props.newsletterOptions && this.props.newsletterOptions.props && this.props.newsletterOptions.props.newsletterSignUpButtonText}
          classes="promoButton" />
      </div> : null;
    let containerClass = 'PromoRibbon-' + this.props.classes;
    return (
      <div className={[this?.props?.parentClass?.[containerClass], styles[containerClass], containerClass, styles['PromoRibbon'], 'PromoRibbon', styles[this.props.classes], this.props.classes].join(" ")}>
        {header}
        {subheader}
        <div className={[this?.props?.parentClass?.["grid-item"], styles["grid-item"], "grid-item"].join(" ")}>
          {this.renderPromoCards()}
        </div>
        {signUpButton}
        {this.renderNewsletter()}
      </div>
    )
  }
}

export default PromoRibbon;
